/* eslint-disable @typescript-eslint/no-explicit-any */

'use client';

import { useRef } from 'react';

export const useDebounce = <Fn extends (...args: any[]) => void>(fn: Fn, delay = 500) => {
  const ref = useRef<number>();

  const clearTimer = () => {
    window.clearTimeout(ref.current);
    ref.current = undefined;
  };

  const getIsPending = () => ref.current !== undefined;

  const debouncedFunction = (...args: unknown[]) => {
    clearTimer();

    ref.current = window.setTimeout(() => {
      ref.current = undefined;
      fn(...args);
    }, delay);
  };

  return [debouncedFunction as unknown as Fn, { clearTimer, getIsPending }] as const;
};
